import { cn } from '@/utils/extra'

export default function SubmitButton ({
  label,
  loading
}) {
  return (
    <button
      type='submit'
      className={cn(
        'inline-flex w-full items-center justify-center rounded-lg bg-indigo-600 px-4 py-3 lg:text-base sm:text-sm font-semibold text-white hover:bg-indigo-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500',
        loading && 'opacity-50 cursor-not-allowed'
      )}
    >
      {loading
        ? (
          <svg className='mr-3 -ml-1 size-5 animate-spin text-white' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
            <title>Loading</title>
            <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
            <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z' />
          </svg>)
        : null}
      {label}
    </button>
  )
}
